import { lazy } from 'react'

const MenuList = lazy(() => import('@/pages/Menu/List'))
const MenuForm = lazy(() => import('@/pages/Menu/Form'))

const menuRoute = {
  path: 'menu',
  meta: { title: '菜单管理', icon: 'MenuOutlined', permission: 'menu:view' },
  children: [
    {
      path: 'list',
      element: <MenuList />,
      meta: { title: '菜单列表', permission: 'menu:list' },
    },
    {
      path: 'add',
      element: <MenuForm />,
      meta: { title: '添加菜单', permission: 'menu:add' },
    },
    {
      path: 'edit/:id',
      element: <MenuForm />,
      meta: { title: '编辑菜单', permission: 'menu:edit' },
    },
  ],
}

export default menuRoute
